module.exports = __webpack_public_path__ + "static/girlMother-dbc0b159d429eab3e568b7b9ca1d7b4f.jpg";